
import { cloneDeep, isEmpty, orderBy as orderByLoadash } from 'lodash';
import extractPositionFromName from './orderChecklist';
import { IQuestion } from '../models/iquestion';
import { EQuestionType } from '../models/equestionType';
import { IGroup } from '../store/reducers/createService';
import { orderQuestionArray } from './orderQuestionArray';
import { IServiceQuestion } from '../models/iserviceQuestion';

export const createQuestionTree = (questionArray: IQuestion[], typeOfData: string) => {
  if(isEmpty(questionArray)) return [];
  const groupArray: IGroup<IQuestion>[] = [];
  questionArray.forEach(question => {
    if(question.type === EQuestionType.group) {
      const groupFormatted = {
        name: question.name,
        id: question._id,
        position: extractPositionFromName(question) as number,
        questionArray: [],
        score: 0,
        totalScore: 0,
      }
      groupArray.push(groupFormatted)
    }
  });

  const groupArrayOrdered = groupArray.sort(orderQuestionArray);

  questionArray.forEach(question => {
    if (question.type === EQuestionType.question) {
      let index;
      if(typeOfData === 'groupAsName') { // id populado
        extractPositionFromName(question)
        index = groupArrayOrdered.findIndex(group => group.name === question.groupName);
      } else { //usado para popular um servico
        extractPositionFromName(question)
        index = groupArrayOrdered.findIndex(group => group.id && question.groupId && group.id === question.groupId);
      if(index > -1) {
        question.groupName = groupArrayOrdered[index].name;
        groupArrayOrdered[index].questionArray.push(question)
      }
    }
  }});

  groupArrayOrdered.forEach(group => {
    let score = 0;
    let totalScore = 0;

    group.questionArray.forEach(question => {
      if (question.answer === 'NO') { score += 0; totalScore += question.weight; }
      else if (question.answer === 'YES') { score += question.weight; totalScore += question.weight; }
    })

    group.questionArray.sort(orderQuestionArray);

    group.score = score;
    group.totalScore = totalScore;
  })

  return groupArrayOrdered;
}

export const createQuestionTreeForEditService = (questionArray: IServiceQuestion[]) => {
  if(isEmpty(questionArray)) return [];
  const groupArray: IGroup<IServiceQuestion>[] = [];
  questionArray.forEach(question => {
    if(question.type === EQuestionType.group) {
      const groupFormatted = {
        name: question.name,
        id: question._id,
        position: extractPositionFromName(question) as number,
        questionArray: [],
        score: 0,
        totalScore: 0,
      }
      groupArray.push(groupFormatted)
    }
  });

  const groupArrayOrdered = groupArray.sort(orderQuestionArray);

  questionArray.forEach(question => {
    if (question.type === EQuestionType.question) {
      let index;// id populado
      extractPositionFromName(question)
      index = groupArrayOrdered.findIndex(group => group.name === question.groupName);
      
      if(index > -1) {
        question.groupName = groupArrayOrdered[index].name;
        groupArrayOrdered[index].questionArray.push(question)
      }
    }
  });

  groupArrayOrdered.forEach(group => {
    let score = 0;
    let totalScore = 0;

    group.questionArray.forEach(question => {
      if (question.answer === 'NO') { score += 0; totalScore += question.weight; }
      else if (question.answer === 'YES') { score += question.weight; totalScore += question.weight; }
    })

    group.questionArray.sort(orderQuestionArray);

    group.score = score;
    group.totalScore = totalScore;
  })

  return groupArrayOrdered;
}

